// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2W3KY","header":"MergedInvoice_header__2Avdm"};